<template>
<ul class="tabs">
  <li
    v-bind:key="index"
    v-for="(option, index) in options"
    :class="['tabs_option', {tabs_option__active: activeTab === index}]"
    @click="setTab(index, option.value)"
  >
    <span>{{option.labelText}}</span>
    <Component
      v-if="option.labelIco && typeof option.labelIco === 'object'"
      :is="option.labelIco"
      class="tabs_option-ico"
    />
    <span
      v-if="option.labelIco && typeof option.labelIco === 'string'"
      class="tabs_option-ico"
    >{{option.labelIco}}</span>
  </li>
</ul>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
class Tabs extends Vue {
  @Prop({
    type: Array,
    required: true
  }) options

  activeTab = 0

  setTab (index, value) {
    this.activeTab = index
    this.$emit('change', index, value)
  }
}

export default Tabs
</script>

<style lang="scss">
.tabs {
  display: flex;
  height: 45px;
  &_option {
    padding: 0 22px;
    align-items: center;
    justify-content: center;
    display: flex;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 25px;
    color: #999999;
    border-top: 1px solid #999999;
    border-bottom: 1px solid #999999;
    border-left: 1px solid #999999;
    cursor: pointer;
    width: 100%;
    @include media_desktop {
      font-size: 20px;
      line-height: 25px;
      padding: 0 30px;
    }
    &:nth-child(2) {
      border-left: none !important;
    }
    &:first-child {
      border: 1px solid #999999;
      box-sizing: border-box;
      border-radius: 45px 0px 0px 45px;
    }
    &:last-child {
      border: 1px solid #999999;
      border-radius: 0px 45px 45px 0px;
    }
    &__active {
      background-color: #fff;
      color: #000000;
      svg path {
        fill: #000000;
      }
    }
  }
  &_option-ico {
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
